import { t } from 'i18next';
import { ObjectSchema } from 'yup';
import { CountryCodeType } from '@bus/models';
import Yup from '../../../services/common/validation';
import { AddressFormModel_OL } from './formModel';
import { getEnumValues } from '../../../services/common/miscUtils';
import { CountyEnum } from '../../../types/countyEnum';

export const getValidationSchema = (isCountryIncluded: boolean): ObjectSchema<Partial<AddressFormModel_OL>> => {
  const shouldBeEmptySchema = Yup.string().oneOf([undefined]);

  return Yup.object({
    addressLine1: Yup.string()
      .matches(/^[a-zA-Z0-9 ]*$/, t('validation:onlyLettersAndNumbers'))
      .required(t('validation:required')),
    addressLine2: Yup.string()
      .matches(/^[a-zA-Z0-9 ]*$/, t('validation:onlyLettersAndNumbers'))
      .notRequired(),
    addressLine3: Yup.string()
      .matches(/^[a-zA-Z0-9 ]*$/, t('validation:onlyLettersAndNumbers'))
      .notRequired(),
    eirCode: Yup.string().eirCode(t('validation:invalidEircode')).required(t('validation:required')),
    town: Yup.string()
      .matches(/^[a-zA-Z0-9 ]*$/, t('validation:onlyLettersAndNumbers'))
      .required(t('validation:required')),
    county: Yup.string().requiredWithMsg().oneOf(getEnumValues(CountyEnum)),
    country: isCountryIncluded
      ? Yup.string().requiredWithMsg().oneOf(getEnumValues(CountryCodeType))
      : shouldBeEmptySchema,
  });
};
